import styled from "styled-components";

export const Container = styled.article`
  width: 90vh;
  max-width: 280px;
  padding: 0.5rem;
  background-color: var(--secondary-color);
  border-radius: 5px;
  border-bottom-right-radius: 50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  height: 4rem;
  @media (min-width: 500px) {
    max-width: 400px;
    font-size: 1.2rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 25%;
  height: 25%;
  align-items: center;
`;

export const InfosContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 75%;
  height: 50%;
`;
export const Title = styled.p`
  color: var(--primary-color);
  width: 60%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
export const Price = styled.p`
  width: 40%;
  color: var(--primary-color);
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
